module.exports = __webpack_public_path__ + "img/full1-min.18881f00.png";